import { useProductViewCommon } from '@/hooks/useProductViewCommon';
import { useProductViewDataSource } from '@/hooks/useProductViewDataSource';
import { ProductViewHook } from '@/types/product-view-model';
import { ProductViewModes } from '@/utils/productStateUtils';

/**
 * Hook used by the product read-only route.
 *
 * It keeps the read-only route explicit while reusing the same common view
 * behavior as edit and Change Request modes.
 */
export function useProductReadOnly(): ProductViewHook {
  const dataSource = useProductViewDataSource(ProductViewModes.ReadOnly);
  return useProductViewCommon(dataSource);
}
